document.addEventListener('DOMContentLoaded', () => {
	// slick default setting
	let defaulsettings = {
		loop: true,
		speed: 700,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		navigation: {
			nextEl: '.swiper-prev',
			prevEl: '.swiper-next',
		},
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		}
	}

	// start slider default
	let allSwipper = []

	document.querySelectorAll('.swiper-slider').forEach((element, i) => {
		let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings
		element.setAttribute(`data-swiper-${i}`, '')
		let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig)
		allSwipper[i] = swiper
	})

	if (document.querySelector('.gallery-block') != null) {
		let gallery_left = new Swiper(`.gallery-swiper-left`, {
			loop: true,
			speed: 700,
			allowTouchMove: false,
		})

		let gallery_middle = new Swiper(`.gallery-swiper-middle`, {
			loop: true,
			speed: 700,
			navigation: {
				nextEl: '[data-gallerynext]',
				prevEl: '[data-galleryprev]',
			},
			pagination: {
				el: '[data-gallerydots]',
				clickable: true,
			},
		})

		let gallery_right = new Swiper(`.gallery-swiper-right`, {
			loop: true,
			speed: 700,
			allowTouchMove: false,
		})

		if (window.innerWidth >= 700) {
			gallery_middle.controller.control = [gallery_right, gallery_left]
		}
	}

	let lineSlider = document.querySelectorAll('.line-tabs-slider');
    if(lineSlider){
        lineSlider.forEach(()=> {
            new Swiper('.line-tabs-slider', {
                loop: true,
                slidesPerView: 1,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                breakpoints: {
                    769: {
                        slidesPerView: 5,
                    },
                    600: {
                        slidesPerView: 3,
                    }
                }
            });
        });
    }

	let imagesSliders = document.querySelectorAll('.images-sliders');
    if(imagesSliders){
        imagesSliders.forEach((item)=>{
            new Swiper(item, {
                rewind: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-img-next",
                    prevEl: ".sw-but-img-prev",
                },
            });
        });
    }

	let iconSlider = document.querySelectorAll('.icon-slider');
    if(iconSlider){
        iconSlider.forEach((item)=>{
            new Swiper(item, {
				speed: 700,
				loop: true,
				slidesPerView: 1,
				spaceBetween: 30,
				autoplay: {
					delay: 2500,
					disableOnInteraction: false,
				},
				breakpoints: {
					1024: {
						slidesPerView: 6
					}
				}
            });
        });
    }

})
